import MuiThemeProvider from '@mui/system/ThemeProvider';
import { themeDark } from '@theme/mui/muiTheme';
import { PropsWithChildren } from 'react';

export const DarkTheme = (props: PropsWithChildren) => {
  return <MuiThemeProvider theme={themeDark} {...props} />;
};
